import React from 'react';

import { Modal as ChakraModal } from '@chakra-ui/react';

import { ModalProps } from '../types';

export const Modal = ({ children, ...restProps }: ModalProps) => {
  return <ChakraModal {...restProps}>{children}</ChakraModal>;
};
